<script>
    import BaseHistoryChart from '../../common/BaseHistoryChart.svelte';

    const expensesDatasets = [
        {
            label: 'Underhållskostnader',
            dataKey: 'total_maintenance_expenses',
            borderColor: '#5a5a5b',
            pointBackgroundColor: '#5a5a5b',
            fill: true,
            gradientColors: { start: 'rgba(90, 90, 91, 0.4)', stop: 'rgba(90, 90, 91, 0.05)' },
            yAxisID: 'y',
            order: 0,
            tooltipSuffix: ' tkr'
        },
        {
            label: 'Driftkostnader',
            dataKey: 'total_operating_expenses',
            borderColor: '#e7e7e4',
            pointBackgroundColor: '#e7e7e4',
            fill: true,
            gradientColors: { start: 'rgba(231, 231, 228, 0.4)', stop: 'rgba(231, 231, 228, 0.05)' },
            yAxisID: 'y',
            order: 1,
            tooltipSuffix: ' tkr'
        },
        {
            label: 'Övriga kostnader',
            dataKey: 'other_external_costs',
            borderColor: '#a4a4a4',
            pointBackgroundColor: '#a4a4a4',
            fill: true,
            gradientColors: { start: 'rgba(138, 127, 114, 0.4)', stop: 'rgba(138, 127, 114, 0.05)' },
            yAxisID: 'y',
            order: 2,
            tooltipSuffix: ' tkr'
        }
    ];

    const expensesYAxes = [
        {
            id: 'y',
            title: 'Kostnader (tkr)',
            position: 'left',
        }
    ];
</script>

<BaseHistoryChart
    headerTitle="Kostnadsfördelning"
    datasetsConfig={expensesDatasets}
    yAxesConfig={expensesYAxes}
    xAxisTitleText="År"
/>
